import React from 'react';
import CareerComponent from '../components/career';

const Career = () => {
  return (
    <>
      <CareerComponent />
    </>
  );
};

export default Career;
